export default __webpack_public_path__ + "../staticImages/einschenk3-260.png";